import Svg, { SvgProps } from './Svg';

export default function SavingsIcon({ ...props }: SvgProps) {
  return (
    <Svg
      viewBox="0 0 450 460"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M107.94 97.4548H0.261696V362.568H107.94L108.34 359.606V196.535L107.94 194.19V97.4548Z"
        fill="url(#paint0_linear_106_1752)"></path>
      <path
        d="M171.164 194.162H107.94V459.275H171.164L171.91 457.226V197.036L171.164 194.162Z"
        fill="url(#paint1_linear_106_1752)"></path>
      <path
        d="M342.07 362.566L449.749 362.566L449.749 97.4533L342.07 97.4533L341.165 99.8252L341.165 360.078L342.07 362.566Z"
        fill="url(#paint2_linear_106_1752)"></path>
      <rect
        width="170.906"
        height="458.557"
        transform="matrix(-1 0 0 1 342.07 0.720703)"
        fill="url(#paint3_linear_106_1752)"></rect>
      <defs>
        <linearGradient
          id="paint0_linear_106_1752"
          x1="107.94"
          y1="362.774"
          x2="107.94"
          y2="97.1869"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#AAF2E1"></stop>
          <stop offset="0.5" stopColor="#9FAEFF"></stop>
          <stop offset="1" stopColor="#A273FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_106_1752"
          x1="171.164"
          y1="459.349"
          x2="171.164"
          y2="194.085"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFD2B9"></stop>
          <stop offset="1" stopColor="#FF6D6D"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_106_1752"
          x1="395.91"
          y1="97.2429"
          x2="395.91"
          y2="362.776"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F7A7F9"></stop>
          <stop offset="1" stopColor="#00DDFB"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_106_1752"
          x1="170.907"
          y1="458.838"
          x2="170.907"
          y2="-0.22511"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F7A7F9"></stop>
          <stop offset="1" stopColor="#6D28FF"></stop>
        </linearGradient>
      </defs>
    </Svg>
  );
}
